module.exports = __webpack_public_path__ + "img/6354622071003762501821105.b2926db0.jpg";